import { FETCH_DELETE_TRANSPORTER_ITEM, RECEIVE_DELETE_TRANSPORTER_ITEM, FAILED_DELETE_TRANSPORTER_ITEM } from '../../actions/transporter/aTransporter-DeleteItem'

const defaultDeleteItemState = {
    deleteItemData: []    
}

export function fetchDeleteItem(state = defaultDeleteItemState, action){
    switch (action.type) {
        case FETCH_DELETE_TRANSPORTER_ITEM:
            return ({deleteItemData: [], inProgress: true})
        case RECEIVE_DELETE_TRANSPORTER_ITEM:
            return Object.assign({}, state, {deleteItemData: action.payload, inProgress: false})
        case FAILED_DELETE_TRANSPORTER_ITEM:
            return ({deleteItemData: [], inProgress: false})
        default:
            return state
    }
}